<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row>
      <v-col>
        <v-btn @click="exportData">
          Выгрузка в CSV
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <material-card
          color="green"
          flat
          full-width
          title="Список пользователей"
        >
          <v-data-table
            :headers="headers"
            :items="data"
            :options.sync="options"
            :server-items-length="totalDesserts"
            :loading="loading"
            class="elevation-1"
          >
            <template #top>
              <v-text-field
                v-model="search"
                label="Поиск по email"
                class="mx-4"
              />
            </template>
            <!-- TODO: fix this v-slot def -->
            <!-- eslint-disable-next-line vue/valid-v-slot -- temp code style fix -->
            <template #item.actions="{ item }">
              <v-icon small class="mr-2" @click="anketa(item)">
                mdi-book-edit
              </v-icon>
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snack"
      :timeout="3000"
      color="error"
      top
    >
      {{ snackText }}

      <template #action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { UsersList, UsersListExport } from '@/graphql/users'
import { TransformFields } from '@/mixins/fields'
import csv from 'async-csv'
export default {
  name: 'UserList',
  layout: 'dashboard',
  apollo: {
    UsersList: {
      query: UsersList,
      variables () {
        return {
          search: this.search,
          limit: this.options.itemsPerPage,
          offset: this.options.itemsPerPage * (this.options.page - 1)
        }
      },
      result ({ data, loading }) {
        this.data = []
        if (
          data.IdentityList !== undefined &&
          data.IdentityList.identity !== undefined
        ) {
          for (const key in data.IdentityList.identity) {
            const item = data.IdentityList.identity[key]
            const fields = TransformFields(item.Fields)
            fields.id = item.Id
            this.data.push(fields)
          }
          this.totalDesserts = data.IdentityList.count
        }
        this.loading = false
      },
      update: data => data.IdentityList
    }
  },
  data () {
    return {
      snack: false,
      snackText: '',
      perpage: [5, 10, 15, 20, 100],
      totalDesserts: 0,
      data: [],
      options: {},
      search: '',
      loading: false,
      headers: [
        {
          sortable: false,
          text: 'ID',
          value: 'id'
        },
        {
          sortable: false,
          text: 'E-mail',
          value: 'email'
        },
        {
          sortable: false,
          text: 'Имя',
          value: 'firstname'
        },
        {
          sortable: false,
          text: 'Фамилия',
          value: 'lastname'
        },
        {
          sortable: false,
          text: 'Телефон',
          value: 'phone'
        },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      csvHeaders: [
        {
          name: 'Id',
          title: 'ID'
        },
        {
          field: 'email',
          title: 'E-mail'
        },
        {
          field: 'CreatedAt',
          title: 'Дата регистрации'
        },
        {
          field: '',
          title: 'Последний визит'
        },
        {
          field: '',
          title: 'Статус'
        },
        {
          name: 'allOrdersSum',
          title: 'Сумма заказов'
        },
        {
          field: '',
          title: 'Имя Менеджера'
        },
        {
          field: '',
          title: 'Откуда узнали'
        },
        {
          field: '',
          title: 'Любимая марка одежды'
        },
        {
          field: '',
          title: 'Интернет-магазин косметики'
        },
        {
          field: '',
          title: 'Интернет-магазин электроники'
        },
        {
          field: '',
          title: 'Интернет-магазин одежды'
        },
        {
          field: '',
          title: 'Интернет-магазин детских товаров'
        },
        {
          field: '',
          title: 'Оценка продукции'
        },
        {
          field: '',
          title: 'Оценка цены'
        },
        {
          field: '',
          title: 'Оценка доставки'
        },
        {
          field: '',
          title: 'Оценка упаковки'
        },
        {
          field: '',
          title: 'Оценка сервиса'
        },
        {
          field: '',
          title: 'Фамилия'
        },
        {
          field: '',
          title: 'Телефон'
        },
        {
          field: '',
          title: 'Номер дисконтной карты (если есть)'
        },
        {
          field: '',
          title: 'Город'
        },
        {
          field: '',
          title: 'Адрес'
        },
        {
          field: '',
          title: 'Получать рассылку'
        },
        {
          field: '',
          title: 'Как к Вам обращаться?'
        },
        {
          field: '',
          title: 'Когда Вас поздравить с днем рождения?'
        },
        {
          field: '',
          title: 'Когда годовщина Вашей свадьбы?'
        },
        {
          field: '',
          title: 'Откуда узнали о nasonpearl.ru?'
        },
        {
          field: '',
          title: 'Получать SMS рассылку'
        },
        {
          field: '',
          title: 'Подтвердил оферту'
        },
        {
          field: '',
          title: 'Подтвердил отправку данных'
        }
      ]
    }
  },
  watch: {
    options (val) {
      this.loading = true
      this.$apollo.queries.UsersList.refetch()
    }
  },
  methods: {
    exportData () {
      this.$apollo
          .query({
            query: UsersListExport
            // variables: {
            //   limit: 10000,
            //   offset: 0
            // }
          })
          .then((data) => {
            if (data?.data?.IdentityListBlob) {
              const buffer = new ArrayBuffer(3)
              const dataView = new DataView(buffer)
              dataView.setUint8(0, 239)
              dataView.setUint8(1, 187)
              dataView.setUint8(2, 191)
              const read = new Uint8Array(buffer)
              const blob = new Blob([read, data?.data?.IdentityListBlob], { type: 'application/csv;charset=UTF-8' })
              const link = document.createElement('a')
              link.href = URL.createObjectURL(blob)
              link.download = 'users.csv'
              link.click()
              URL.revokeObjectURL(link.href)
            } else {
              this.snackText = 'Ошибка выгрузки'
              this.snack = true
            }
          })
          .catch((error) => {
            this.snackText = error
            this.snack = true
          })
    },
    async toCsv (data) {
      const columnNames =
           [...this.csvHeaders
                  .reduce((columns, row) => {
                    columns.add(row.title)// check each object to compile a full list of column names
                    return columns
                  }, new Set())]

      const csvInput = []
      csvInput.push(columnNames)
      csvInput.push(
          ...data.map(row => this.csvHeaders.map((column) => {
            if (column?.name && column.name.length > 0) {
              return row[column.name]
            }
            if (column?.field && column.field.length > 0) {
              return row?.Fields.find(item => item.name === column.field)?.value
            }
            return ''
          }))
      )
      return await csv.stringify(csvInput)
    },
    // TODO: refactor this chunk
    /* eslint-disable no-console */
    anketa (item) {
      this.snackText = 'Еще не готов данный функционал'
      this.snack = true
    },
    editItem (item) {
      this.$router.push({ path: '/users/' + item.id })
    },
    banItem (item) {
      this.snackText = 'Еще не готов данный функционал'
      this.snack = true
    }
    /* eslint-enable no-console */
  }
}
</script>
